import { FeatureLike } from "ol/Feature";
import { MileageTheme } from "../../context/theme/MileageTheme";
import { Fill, Stroke, Style } from "ol/style";

export const MileageStyle = (
  feature: FeatureLike,
  resolution: number,
  mileageTheme: MileageTheme,
  year: number,
  opacity: number,
  selectedBoundaryId?: string,
) => {
  const key = `Change${year}`;
  const props = feature.getProperties();
  const change = props[key];
  const id = props["Id"];

  const selectedOpacity = getBoundaryOpacity(id, selectedBoundaryId, opacity);

  return new Style({
    fill: new Fill({
      color: addOpacity(getFillColor(change, mileageTheme), selectedOpacity),
    }),
    stroke: new Stroke({
      color: addOpacity("rgba(0, 0, 0, 1)", selectedOpacity),
      width:
        selectedBoundaryId ?
          id === selectedBoundaryId ?
            1.5
          : 0.5
        : 0.5,
    }),
  });
};
export const getFillColor = (
  change: number,
  mileageTheme: MileageTheme,
): string => {
  let fillColor = "black";

  if (change < -40) {
    fillColor = mileageTheme.darkRed; // -50% to -40%
  } else if (change < -30) {
    fillColor = mileageTheme.mediumRed; // -40% to -30%
  } else if (change < -20) {
    fillColor = mileageTheme.lightRed; // -30% to -20%
  } else if (change < -10) {
    fillColor = mileageTheme.darkOrange; // -20% to -10%
  } else if (change < 0) {
    fillColor = mileageTheme.mediumOrange; // -10% to 0%
  } else if (change < 10) {
    fillColor = mileageTheme.lightOrange; // 0% to 10%
  } else if (change < 20) {
    fillColor = mileageTheme.yellow; // 10% to 20%
  } else if (change < 30) {
    fillColor = mileageTheme.green1; // 20% to 30%
  } else if (change < 40) {
    fillColor = mileageTheme.green2; // 30% to 40%
  } else if (change < 50) {
    fillColor = mileageTheme.green3; // 40% to 50%
  } else if (change < 60) {
    fillColor = mileageTheme.green4; // 50% to 60%
  } else if (change < 70) {
    fillColor = mileageTheme.green5; // 60% to 70%
  } else {
    fillColor = mileageTheme.green6; // 70% to 75%+
  }
  return fillColor;
};

const addOpacity = (color: string, opacity: number): string => {
  // If already rgba, replace alpha
  if (color.startsWith("rgba")) {
    return color.replace(/[\d.]+\)$/g, `${opacity})`);
  }

  // Convert hex -> rgba
  const r = parseInt(color.slice(1, 3), 16);
  const g = parseInt(color.slice(3, 5), 16);
  const b = parseInt(color.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

function getBoundaryOpacity(
  id: string,
  selectedId: string | undefined,
  opacity: number,
) {
  if (id === selectedId) return 1;

  if (selectedId && id !== selectedId) return 0.5;

  return opacity;
}
